import type { ReactNode } from 'react';

interface AlertProps {
  variant: 'info' | 'success' | 'warning' | 'error';
  children: ReactNode;
}

export function Alert({ variant, children }: AlertProps) {
  return <div className={`sarnia-alert sarnia-alert--${variant}`} role="alert">{children}</div>;
}
